import {AppService} from "../typescript/app/app.service";

class CustomerServiceService {

    static API_URL = "/api/customerService";

    static start() {
        return AppService.postAuthorized(this.API_URL + "/start");
    }

    static stop(reason: string) {
        return AppService.postAuthorized(this.API_URL + "/stop?reason=" + reason);
    }

}

export {CustomerServiceService};